import Vue from 'vue';
export default Vue.extend({
    name: 'VideoCardSkeleton',
    props: {},
    computed: {},
    components: {},
});
